<div class="container-fluid p-3">
  <!-- Sección de Carga Masiva -->
  <mat-card>
    <mat-card-header class="pb-0">
      <mat-card-title>Carga Masiva de Bonificaciones</mat-card-title>
    </mat-card-header>
    <mat-card-content class="pt-3">
      <div class="row">
        <div class="col-12 col-md-12">
          <input type="file" #fileInput (change)="onFileSelected($event)" accept=".xlsx,.xls" style="display: none">
          <div class="d-flex gap-2 flex-column flex-md-row">
            <button mat-flat-button color="primary" (click)="fileInput.click()">
              <mat-icon>upload_file</mat-icon>
              Seleccionar Archivo
            </button>
            <button mat-flat-button color="warn" [disabled]="!selectedFile" (click)="procesarArchivo()">
              <mat-icon>check_circle</mat-icon>
              Procesar Archivo
            </button>
            <button mat-flat-button color="basic" [disabled]="!selectedFile" (click)="cancelarSeleccionArchivo()">
              <mat-icon>close</mat-icon>
              Cancelar
            </button>
            <span class="ms-2 align-self-center" *ngIf="selectedFile">
              {{selectedFile.name}}
            </span>
          </div>
          <div class="mt-2">
            <small class="text-muted">
              El archivo Excel debe contener las columnas: periodo, c_vend, c_concepto, valor, observaciones
            </small>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- Panel de Instrucciones -->
  <mat-expansion-panel class="mb-3 mt-3">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon class="mr-2">help_outline</mat-icon>
        Instrucciones de Carga
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="instructions-container">
      <div class="mb-3">
        <h3 class="text-lg font-semibold mb-2">Formato del Archivo</h3>
        <p class="text-gray-600 mb-4">
          Para cargar las bonificaciones extras, utilice un archivo Excel con el formato especificado.
          El archivo debe contener las siguientes columnas con sus respectivos formatos:
        </p>
      </div>

      <!-- Tabla de Campos Requeridos -->
      <div class="mb-4">
        <table mat-table [dataSource]="camposRequeridos" class="w-100 mb-4">
          <ng-container matColumnDef="campo">
            <th mat-header-cell *matHeaderCellDef>Campo</th>
            <td mat-cell *matCellDef="let element">{{element.campo}}</td>
          </ng-container>

          <ng-container matColumnDef="formato" style="width: 10%;">
            <th mat-header-cell *matHeaderCellDef>Formato</th>
            <td mat-cell *matCellDef="let element">{{element.formato}}</td>
          </ng-container>

          <ng-container matColumnDef="ejemplo" style="width: 20%;">
            <th mat-header-cell *matHeaderCellDef>Ejemplo</th>
            <td mat-cell *matCellDef="let element">{{element.ejemplo}}</td>
          </ng-container>

          <ng-container matColumnDef="descripcion" style="width: 20%;">
            <th mat-header-cell *matHeaderCellDef>Descripción</th>
            <td mat-cell *matCellDef="let element">{{element.descripcion}}</td>
          </ng-container>
          

          <tr mat-header-row *matHeaderRowDef="columnasCamposRequeridos"></tr>
          <tr mat-row *matRowDef="let row; columns: columnasCamposRequeridos;"></tr>
        </table>
      </div>

      <div class="mb-4">
        <h4 class="text-md font-semibold mb-2">Notas Importantes:</h4>
        <ul class="list-disc pl-5 text-gray-600">
          <li>No modificar el orden de las columnas</li>
          <li>No dejar campos vacíos</li>
          <li>Los valores deben ser números positivos</li>
          <li>El periodo debe ser una fecha válida en formato YYYYMM</li>
        </ul>
      </div>

      <div class="flex justify-start">
        <a mat-raised-button color="primary" href="/assets/templates/bonificaciones/plantilla_bonificaciones.xlsx"
          download="plantilla_bonificaciones.xlsx" class="flex items-center">
          <mat-icon class="mr-2">download</mat-icon>
          Descargar Plantilla Excel
        </a>
      </div>

    </div>
  </mat-expansion-panel>

  <!-- Formulario de Bonificación -->
  <mat-card class="mt-3">
    <mat-card-header class="pb-0">
      <mat-card-title>{{ isEditing ? 'Editar' : 'Crear' }} Bonificación Extra</mat-card-title>
    </mat-card-header>
    <mat-card-content class="pt-3">
      <form [formGroup]="bonificacionForm" (ngSubmit)="onSubmit()">
        <div class="row mb-3">
          <div class="col-md-2 col-sm-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Periodo</mat-label>
              <mat-select formControlName="periodo" [disabled]="isEditing"
                [matTooltip]="isEditing ? 'No se puede modificar el periodo en modo edición' : ''"
                [matTooltipPosition]="'above'">
                <mat-option *ngFor="let periodo of periodosAbiertos" [value]="periodo.periodo">
                  {{periodo.periodo}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="bonificacionForm.get('periodo')?.hasError('required')">
                El periodo es requerido
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-4 col-sm-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Concepto</mat-label>
              <mat-select formControlName="c_concepto">
                <mat-option *ngFor="let concepto of conceptos" [value]="concepto.codigo">
                  {{concepto.codigo}} - {{concepto.descripcion}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="bonificacionForm.get('c_concepto')?.hasError('required')">
                El concepto es requerido
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-6 col-sm-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Vendedor</mat-label>
              <input type="text" matInput [formControl]="vendedorControl" [matAutocomplete]="auto"
                [readonly]="isEditing"
                [matTooltip]="isEditing ? 'No se puede modificar el vendedor en modo edición' : ''"
                [matTooltipPosition]="'above'">
              <button mat-icon-button matSuffix (click)="mostrarListaVendedores()" type="button" [disabled]="isEditing"
                [matTooltip]="isEditing ? 'No se puede modificar el vendedor en modo edición' : ''">
                <mat-icon>search</mat-icon>
              </button>
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayVendedor">
                <mat-option *ngFor="let vendedor of vendedoresFiltrados | async" [value]="vendedor">
                  {{vendedor.codigo_vendedor}} - {{vendedor.nombre_vendedor}}
                </mat-option>
              </mat-autocomplete>
              <mat-error *ngIf="bonificacionForm.get('c_vend')?.hasError('required')">
                El vendedor es requerido
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-md-2 col-sm-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Valor</mat-label>
              <input matInput type="text" formControlName="valor" required
                [value]="bonificacionForm.get('valor')?.value | currency:'COP':'symbol-narrow':'1.0-0'"
                (input)="onValorInput($event)">
              <mat-error *ngIf="bonificacionForm.get('valor')?.hasError('required')">
                El valor es requerido
              </mat-error>
              <mat-error *ngIf="bonificacionForm.get('valor')?.hasError('min')">
                El valor debe ser mayor a 0
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-10 col-sm-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Observaciones</mat-label>
              <textarea matInput formControlName="observaciones" style="resize: none;" rows="1"></textarea>
              <mat-error *ngIf="bonificacionForm.get('observaciones')?.hasError('maxlength')">
                Las observaciones no pueden exceder 200 caracteres
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="d-flex gap-2 mt-3 justify-content-end">
          <button mat-flat-button color="primary" type="submit" [disabled]="!bonificacionForm.valid || isLoading"
            class="btn btn-primary">
            <span *ngIf="!isLoading">{{ isEditing ? 'Actualizar' : 'Guardar' }}</span>
          </button>
          <button mat-flat-button type="button" (click)="onCancel()" class="btn btn-secondary" *ngIf="isEditing"
            [disabled]="isLoading">
            Cancelar
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>

  <!-- Lista de Bonificaciones -->
  <mat-card class="mt-3">
    <mat-card-header class="pb-0">
      <mat-card-title>Lista de Bonificaciones Extras</mat-card-title>
    </mat-card-header>
    <mat-card-content class="pt-3">
      <!-- Barra de búsqueda -->
      <div class="col-md-6 col-sm-12 mb-2 mb-sm-0">
        <mat-form-field appearance="outline" class="w-100 mb-3">
          <mat-label>Buscar</mat-label>
          <input matInput (keyup)="applyFilter($event)" [formControl]="searchControl" placeholder="Buscar bonificación por concepto, periodo. o valor">
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </div>

      <!-- Tabla -->
      <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" class="table w-100">
          <!-- Periodo Column -->
          <ng-container matColumnDef="periodo">
            <th mat-header-cell *matHeaderCellDef style="width: 15%; font-size: 11px;">Periodo</th>
            <td mat-cell *matCellDef="let element" style="vertical-align: middle; font-size: 11px;">
              {{element.periodo}}
              <mat-icon *ngIf="!isPeriodoAbierto(element.periodo)" 
                       matTooltip="Periodo cerrado"
                       class="text-warning" 
                       style="font-size: 16px; height: 16px; width: 16px; margin-left: 4px;vertical-align: middle;">
                lock
              </mat-icon>
            </td>
          </ng-container>

          <!-- Concepto Column -->
          <ng-container matColumnDef="c_concepto">
            <th mat-header-cell *matHeaderCellDef style="width: 15%; font-size: 11px;">Concepto</th>
            <td mat-cell *matCellDef="let element" style="vertical-align: middle; font-size: 11px;">
              {{getConceptoDescripcion(element.c_concepto)}}
            </td>
          </ng-container>

          <!-- Vendedor Column -->
          <ng-container matColumnDef="c_vend">
            <th mat-header-cell *matHeaderCellDef style="width: 25%; font-size: 11px;">Vendedor</th>
            <td mat-cell *matCellDef="let element" style="vertical-align: middle; font-size: 11px;">
              {{getVendedorNombre(element.c_vend)}}
            </td>
          </ng-container>

          <!-- Valor Column -->
          <ng-container matColumnDef="valor">
            <th mat-header-cell *matHeaderCellDef style="width: 10%; font-size: 11px;">Valor</th>
            <td mat-cell *matCellDef="let element" [ngClass]="{'text-danger': element.valor < 0}"
              style="vertical-align: middle; font-size: 11px;">
              {{element.valor | currency:'COP':'symbol-narrow':'1.0-0'}}
            </td>
          </ng-container>

          <!-- Fecha Creación Column -->
          <ng-container matColumnDef="fecha_creacion">
            <th mat-header-cell *matHeaderCellDef style="width: 15%; text-align: center;font-size: 11px;">Fecha Creación</th>
            <td mat-cell *matCellDef="let element" style="vertical-align: middle; text-align: center;font-size: 11px;">
              {{element.fecha_creacion | date:'dd-MM-yyyy'}}
            </td>
          </ng-container>

          <!-- Acciones Column -->
          <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef style="width: 15%; font-size: 13px;" class="text-center">Acciones</th>
            <td mat-cell *matCellDef="let element" class="text-center">
              <div style="display: flex; justify-content: center; gap: 4px;">
                <button mat-icon-button 
                        [disabled]="!canEdit(element) || !isPeriodoAbierto(element.periodo)"
                        (click)="editarBonificacion(element)"
                        matTooltip="{{ !isPeriodoAbierto(element.periodo) ? 'No se puede editar un registro de un periodo cerrado' : 
                                    !canEdit(element) ? 'No se puede modificar bonificaciones con conceptos base del sistema' : 
                                    'Editar' }}">
                  <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button 
                        [disabled]="!canDelete(element) || !isPeriodoAbierto(element.periodo)"
                        (click)="eliminarBonificacion(element)"
                        matTooltip="{{ !isPeriodoAbierto(element.periodo) ? 'No se puede eliminar un registro de un periodo cerrado' : 
                                    !canDelete(element) ? 'No se puede eliminar bonificaciones con conceptos base del sistema' : 
                                    'Eliminar' }}">
                  <mat-icon>delete</mat-icon>
                </button>
                <button mat-icon-button (click)="verDetalles(element)" matTooltip="Ver detalles">
                  <mat-icon class="text-dark">info</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="['periodo', 'c_concepto', 'c_vend', 'valor', 'fecha_creacion', 'acciones']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['periodo', 'c_concepto', 'c_vend', 'valor', 'fecha_creacion', 'acciones'];"></tr>

          <!-- Mensaje cuando no hay datos -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell text-center" [attr.colspan]="displayedColumns.length" style="padding: 20px;">
              No se encontraron registros
            </td>
          </tr>
        </table>

        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Seleccionar página"></mat-paginator>
      </div>
    </mat-card-content>
  </mat-card>
</div>